import {
  computed,
  defineAsyncComponent,
  defineComponent,
  inject,
  markRaw,
  provide,
  reactive,
  ref,
  watch,
  watchEffect,
} from 'vue'
import { singletonInstanceSummoner } from '../../common/singletonInstanceSummoner'
import { CoreFrontendFrameworks } from '../../types'

export const makeItReactive = <T>(obj): T => {
  return reactive(obj)
}

/**
 * Vue Framework Util functions をまとめたもの
 */
export class FrameworkFrameworkApiRefForCoreFramework {
  fw: CoreFrontendFrameworks

  constructor(fw: CoreFrontendFrameworks = 'vue') {
    this.fw = fw
  }

  /**
   * Reactivity を付与する
   */
  makeItReactive = makeItReactive
  defineAsyncComponent = defineAsyncComponent
  defineComponent = defineComponent
  ref = ref
  computed = computed
  watch = watch
  watchEffect = watchEffect
  provide = provide
  inject = inject
  markRaw(maybeObject) {
    if (typeof maybeObject !== 'object') {
      return maybeObject
    }
    return markRaw(maybeObject)
  }

  get makeItNonReactive() {
    return this.markRaw
  }

  /**
   * Reactivity keep しつつ、新しいpropertyを付与する
   */
  set(obj, key, val) {
    obj[key] = val
    return obj
  }

  static get instance() {
    return singletonInstanceSummoner(
      'FrameworkUtils',
      FrameworkFrameworkApiRefForCoreFramework,
      [(process.env.CORE_FW_FRONTEND_FRAMEWORK as CoreFrontendFrameworks) || 'vue'],
    )
  }
}

globalThis.$frontendFrameworkApiRefForCoreFramework =
  FrameworkFrameworkApiRefForCoreFramework.instance
globalThis.$frameworkUtils = globalThis.$frontendFrameworkApiRefForCoreFramework

export const $frameworkUtils = globalThis.$frontendFrameworkApiRefForCoreFramework
